// Library imports
import styled from "styled-components";
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import store, { RootState } from "store";

// Local imports
import CategoryFilter from "../../Common/Components/CategoryFilter";
import SearchContentBar from "../Search/Components/SearchContentBar";
import Pills from "../../Common/Components/Pills";
import WhatsHappeningNowTab from "../WhatsHappeningNow/Components/WhnTab";
import FavoriteNewsContainer from "../Favorites/Components/FavoriteNewsContainer";
import MyAccountsContainer from "../MyAccounts/Components/myAccounts";
import MostEngagedTab from "../MostEngaged/Components/MostEngagedTab";
import SearchTab from "../Search/Components/SearchTab";
import ToggleView from "./ToggleView";
import {
  PATH_HAPPENING_NOW,
  PATH_MY_ACCOUNTS,
  PATH_FAVOURITES,
  PATH_SEARCH,
  PATH_MOST_ENGAGED,
} from "../../../constants/index";
import StickyHeader from "../../Common/Components/StickyHeader";
import StickyHeaderContent from "../../Common/Components/StickyHeaderContent";
import { IAccountItem, IAccountSearchItem, ISelectedAccounts } from "../interfaces";
import {
  accountSearch,
  resetSearchAccounts,
} from "../MyAccounts/actions";
import { resetSearchedArticles } from "../Search/actions";
import FloatingSidebarTwo from "modules/Common/Components/FloatingSidebarTwo";
import AdvancedSearch from "./AdvancedSearch";
import { ASSET_LIST } from "constants/types";
import { SEARCH_ARTICLES } from "constants/actionTypes";
import { callSearchArticlesCancelAPI } from "modules/Services/SearchService";
import { GLOBAL_ACTION } from "modules/GlobalActions";
import { resetFavoriteArticles } from "../Favorites/actions";
import { addGillRoyIcon } from "utils";

interface IContentInner {
  tab: string;
}

const ContentInner: React.FC<IContentInner> = (props) => {
  // Local States
  const [accountsSearchMode, setAccountsSearchMode] = useState(false);
  const [allSearchTerms, setAllSearchTerms] = useState<string[]>([]);
  const [searchTerms, setSearchTerms] = useState<any[]>([]);
  const [extendedSearchTerms, setExtendedSearchTerms] = useState([]);
  const [isSearchMode, setIsSearchMode] = useState(false);
  const [firstMount, setFirstMount] = useState(true);
  const [isListView, setIsListView] = useState(localStorage.getItem("isListView") === "true");

  //Redux States
  const searchedAccounts: IAccountSearchItem[] = useSelector((state: RootState) => state.accountSearch.data);
  const myAccounts: IAccountItem[] = useSelector((state: RootState) => state.myAccounts.data);
  const selectedAccounts: ISelectedAccounts[] = useSelector((state: RootState) => state.myAccounts.selectedAccounts);
  const showAdvancedSearchSidebar: boolean = useSelector(
    (state: RootState) => state.uiReducer.showAdvancedSearchSidebar
  );

  useEffect(() => {
    if (props.tab) {
      setSearchTermsMethod([]);
      setExtendedSearchTerms([]);
      setSearchTerms([]);
      setAllSearchTerms([]);
      if (props.tab !== "myaccounts") setAccountsSearchMode(false);
      resetSearchedArticles();
      resetAdvancedSearch();
      callSearchArticlesCancelAPI();
    }
  }, [props.tab]);

  const setSearchTermsMethod = (searchTerms: string[]) => {
    if (searchTerms.length === 0) {
      setIsSearchMode(false);
      setAccountsSearchMode(false);
      setAllSearchTerms([]);
    } else {
      setAllSearchTerms(searchTerms);
      setIsSearchMode(true);
      setAccountsSearchMode(true);
      if (props.tab === "myaccounts") {
        if (searchTerms.length == 1) {
          accountSearch(searchTerms[0]);
        } else {
          accountSearch(searchTerms);
        }
      }
    }
  };

  const handleToggle = (value: boolean) => {
    localStorage.setItem("isListView", `${value}`);
    setIsListView(value);
  };

  const contentPageTabs = () => {
    return (
      <div className="tabs-wrapper d-flex padding-top-md">
        <ul>
          <li>
            <Link to={"/content/" + PATH_SEARCH}>
              <Pills
                active={props.tab === PATH_SEARCH ? true : false}
                title="Smart Content"
                idBtn="smart-content-tab"
              />
            </Link>
          </li>
          <li>
            <Link to={"/content/" + PATH_HAPPENING_NOW} >
              <Pills
                active={props.tab === PATH_HAPPENING_NOW ? true : false}
                title="What's Happening Now"
                idBtn="whats-happening-now-tab"
              />
            </Link>
          </li>
          <li>
            <Link to={"/content/" + PATH_MY_ACCOUNTS} >
              <Pills
                active={props.tab === PATH_MY_ACCOUNTS ? true : false}
                title="For My Accounts"
                idBtn="for-y-accounts-tab"
              />
            </Link>
          </li>
          <li>
            <Link to={"/content/" + PATH_FAVOURITES} >
              <Pills
                active={props.tab === PATH_FAVOURITES ? true : false}
                title="Favorites"
                idBtn="favorites-tab"
              />
            </Link>
          </li>
          {/* route for implementing drag and drop */}
        </ul>
      </div>
    );
  };

  const contentTabsToggleOnly = () => {
    return (
      <div className="tabs-wrapper d-flex padding-top-md toggle-wrapper">
        <ul>
          <li>
            <ToggleView isListView={isListView} onToggle={handleToggle} />
          </li>
        </ul>
      </div>
    );
  };

  const showSearchBar =
    (props.tab === "myaccounts" && myAccounts.length > 0) || props.tab === "search" ? true : false;

  const resetAdvancedSearch = () => {
    store.dispatch({
      type: ASSET_LIST.RESET_ADVANCED_SEARCH,
    });
    store.dispatch({
      type: SEARCH_ARTICLES.RESET_ADVANCED_SEARCH,
    });
  };

  useEffect(() => {
    if (firstMount) {
      store.dispatch({
        type: GLOBAL_ACTION.ADVANCED_SEARCH_CHECK,
        payload: false,
      });
      setFirstMount(false);
    }
    addGillRoyIcon();
    return () => {
      resetFavoriteArticles();
    };
  }, []);

  return (
    <>
      <Wrapper style={allSearchTerms.length === 0 && props.tab === PATH_SEARCH ? { height: "101vh" } : {}}>
        <div className="stickey-after">
          <div className="d-flex flex-row">
            {contentTabsToggleOnly()}
            {showSearchBar && (
              <>
                <div className="width-100 align-items-center">
                  <SearchContentBar
                    searchTerms={searchTerms}
                    setSearchTerms={setSearchTerms}
                    extendedSearchTerms={extendedSearchTerms}
                    setExtendedSearchTerms={setExtendedSearchTerms}
                    onSearch={setSearchTermsMethod}
                    editable={true}
                    onFirstTime={false}
                    interestedPage={props.tab === "intrested"}
                    selectedTab={props.tab}
                    setAccountsSearchMode={setAccountsSearchMode}
                    resetSearchAccounts={resetSearchAccounts}
                    isContentPage={true}
                    disableSaveSearch={true}
                    disableHintContent={props.tab === "myaccounts"}
                    createCampaignFlow={props.tab === "search"} //* if Smart Content tab then show save
                    CrossRight={props.tab === "myaccounts" ? "0px" : "180px"}
                    search
                    and
                    trigger
                    createCampaign
                    flow
                  />
                </div>
                {props.tab === "myaccounts" && (
                  <div className="ms-3">
                    <CategoryFilter disable={(selectedAccounts?.length ?? 0) <= 0 && isSearchMode} />
                  </div>
                )}
              </>
            )}
          </div>
          <StickyHeader>
            <StickyHeaderContent
              label={"Content explorer"}
              subLabel={
                window.location.pathname.endsWith("/search")
                  ? "Search, select and drag content to create emails"
                  : "Select and drag content to create emails"
              }
            >
              {contentPageTabs()}
            </StickyHeaderContent>
          </StickyHeader>
        </div>
        <div className="tabs-content-wrapper padding-bottom-lg">
          {props.tab === PATH_SEARCH ? (
            <SearchTab
              inContentSmartSourced={true}
              inEditionSmartSourced={false}
              searchTerms={allSearchTerms}
              isListView={isListView}
            />
          ) : null}
          {props.tab === PATH_HAPPENING_NOW ? (
            <WhatsHappeningNowTab inEditionSmartSourced={false} isListView={isListView} />
          ) : null}
          {props.tab === PATH_MY_ACCOUNTS ? (
            <MyAccountsContainer
              isListView={isListView}
              allSearchTerms={allSearchTerms}
              searchedAccounts={searchedAccounts}
              searchMode={accountsSearchMode}
              setSearchMode={setAccountsSearchMode}
              setSearchTerms={setSearchTerms}
              onFirstSearch={setSearchTermsMethod}
            />
          ) : null}
          {/* {props.tab === PATH_MOST_ENGAGED ? <MostEngagedTab isListView={isListView} /> : null} */}
          {props.tab === PATH_FAVOURITES ? <FavoriteNewsContainer isListView={isListView} /> : null}
        </div>
      </Wrapper>
      <FloatingSidebarTwo
        isToggle={showAdvancedSearchSidebar}
        advancedSearch={true}
        className="detail-person-view"
        searchTerms={allSearchTerms}
      >
        <AdvancedSearch />
      </FloatingSidebarTwo>
    </>
  );
};

export default ContentInner;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  padding: 120px 90px 0 90px;
  @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
    padding: 90px 65px 0 65px;
  }
  div.stickey-after {
    display: flex;
    flex-direction: column;
    padding-top: 25px;
  }
  .smart-content-heading {
    color: #424b50;
    font-size: 26px;
    line-height: 47px;
    font-weight: bold;
    font-family: "Roboto Slab";
    padding-top: 36px;
  }
  .full-length {
    width: 100%;
  }
  .sticky-header-tabs-container {
    display: flex;
    align-items: center;
    justify-content: end;
    .search-bar {
      min-width: 350px;
      .search-terms {
        width: calc(100% - 50px);
        @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
          width: calc(100% - 40px);
        }
      }
      .search-input,
      .clear-search {
        display: none;
      }
    }
  }
  .search-icon-main {
    height: 100%;
    cursor: pointer;
    padding-left: 20px;
    margin-top: -8px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-left: 15px;
      margin-top: 0px;
    }
  }
  .tabs-wrapper {
    justify-content: space-between;
    align-items: center;
    padding-bottom: 21px;
    padding-top: 8px;
    margin-left: -5px;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      padding-bottom: 7px;
      padding-top: 7px;
    }
    &.toggle-wrapper {
      padding-bottom: 0px;
      padding-top: 0px;
      li {
        margin: 0px 5px;
      }
    }
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      display: flex;
      flex-wrap: wrap;
      li {
        margin: 5px 5px;
      }
    }
    p.articles-count {
      margin-bottom: 0px;
      color: rgb(126, 126, 126);
      font-size: 14px;
      font-weight: 600;
      font-family: "robotomedium";
      white-space: nowrap;
      display: inline-block;
      float: right;
    }
  }

  .tabs-content-wrapper {
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    div[role="DraggableBox"] {
      height: 100%;
      div[role="Box"] {
        height: 100%;
      }
    }
    .list-style,
    .small-three {
      div[role="DraggableBox"] {
        height: auto;
        div[role="Box"] {
          height: auto;
        }
      }
    }
    .small-three {
      height: 100%;
      flex-direction: column;
      display: flex;
      justify-content: start;
      align-items: center;
      flex-wrap: wrap;
      &:not(.small-two-only) {
        div[role="DraggableBox"]:nth-of-type(2) {
          margin-top: 15px;
        }
      }
      &.small-two-only {
        justify-content: space-between;
      }
    }
  }
  h1 {
    color: #424b50;
    font-size: 40px;
    font-weight: 600;
    line-height: 47px;
    margin-bottom: 10px;
    display: block;
    font-family: "Roboto Slab", serif;
    @media all and (max-width: 1439px), (max-height: 729px), (-webkit-device-pixel-ratio: 1.25) {
      font-size: 28px;
      line-height: 33px;
    }
  }
`;
